import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { ServiceTemplatesService } from 'src/api/v2';
import { SERVICE_TEMPLATES_LIST } from 'src/constants/hook-keys';

const useServiceTemplatesList = () => {
  const [serviceTemplateService] = useState(new ServiceTemplatesService());

  const {
    data: allServiceTemplates,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [SERVICE_TEMPLATES_LIST],
    queryFn: () => serviceTemplateService.getServiceTemplates(),
    staleTime: 1000 * 60 * 30,
    refetchOnMount: true,
    keepPreviousData: false,
  });

  return {
    allServiceTemplates,
    isLoading,
    isError,
  };
};

export default useServiceTemplatesList;
